module.exports = __webpack_public_path__ + "img/pos4_banner.a9a55b25.png";